'use client';

import * as React from 'react';
import { BackToMenuButton as SharedBackToMenuButton } from '~shared/components/Buttons/BackToMenuButton';
import { useWaiterRouter } from '../client';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Button redirecting user to the menu page of the company (waiter app menu).
 */
export var BackToMenuButton = function BackToMenuButton() {
  var router = useWaiterRouter();
  var onBackToMenu = React.useCallback(function () {
    router.replace('menu');
  }, [router]);
  return /*#__PURE__*/_jsx(SharedBackToMenuButton, {
    onBackToMenu: onBackToMenu
  });
};